import  { FC } from 'react'
import upArrowIcon from '../../../public/assets/images/upArrowIcon.svg';

const ScrollToTopBtn : FC<{mobileOnly?: boolean}> = ({mobileOnly}) => {
  return (
    <div>
      <div className={`flex justify-end items-center gap-2 !mt-[20px] !mb-[20px] min-[992px]:hidden ${mobileOnly? "tablet:!hidden" : ""}`}>
        <div className="ds-iconlink flex items-center gap-2" data-ds-theme="vessel" data-ds-variant="basic" data-ds-version="2">
          <div className="ds-iconlink-icon">
            <img alt="up arrow icon" aria-hidden="true" src={upArrowIcon} width="24" height="24" />
          </div>
          <div className="ds-iconlink-content">
            <a
              className="ds-iconlink-link !text-[#0074AD] -book text-base !underline"
              href="#top"
              onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
              data-analytics-click="BackToTop"
              data-analytics-type="icon link"
            >
              Back to Top
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ScrollToTopBtn
